import React from "react";

/**
 * Eksvidi brand mark.
 * - isotipo: cuadrado coral con la K (palo + triángulo en espejo).
 * - wordmark: "eksvidi" (eks gris carbón / vidi coral) opcional.
 * - sub: "by Ekspertium" opcional.
 */
export function Logo({ size = 36, showWordmark = true, showSub = true, className = "", invert = false }) {
  const eksColor = invert ? "#FFFFFF" : "#2C2C2A";
  const vidiColor = "#D85A30";
  const subColor = invert ? "rgba(255,255,255,0.55)" : "#7A786F";
  return (
    <div className={`flex items-center gap-2.5 ${className}`} data-testid="eksvidi-logo">
      <svg
        viewBox="0 0 100 100"
        width={size}
        height={size}
        className="shrink-0"
        aria-hidden="true"
      >
        <rect width="100" height="100" rx="22" ry="22" fill="#D85A30" />
        <rect x="22" y="22" width="13" height="56" fill="#FFFFFF" />
        <polygon points="35,50 78,22 78,78" fill="#FFFFFF" />
      </svg>
      {showWordmark && (
        <div className="flex flex-col leading-tight">
          <div className="font-heading font-medium text-[18px] tracking-tight" style={{ letterSpacing: "-0.01em" }}>
            <span style={{ color: eksColor }}>eks</span><span style={{ color: vidiColor }}>vidi</span>
          </div>
          {showSub && (
            <div className="text-[10px] font-medium" style={{ color: subColor, letterSpacing: "0.04em" }}>
              by Ekspertium
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export function LogoIcon({ size = 36, className = "" }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} className={className} aria-hidden="true">
      <rect width="100" height="100" rx="22" ry="22" fill="#D85A30" />
      <rect x="22" y="22" width="13" height="56" fill="#FFFFFF" />
      <polygon points="35,50 78,22 78,78" fill="#FFFFFF" />
    </svg>
  );
}
